<template>
  <div>
    <div
      v-if="ppaPortfoliosWithInstructions.length > 0"
      class="d-flex flex-column gap-2"
    >
      <PortfolioInstructionsDisplay
        v-for="portfolio in ppaPortfoliosWithInstructions"
        :key="portfolio.id"
        :portfolio="portfolio"
        :registryDevices="props.registryDevices"
      />
    </div>
    <p v-else class="mb-0 text-muted fs-8">
      {{ $t("ppa_strategy.no_ppa_instructions") }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { filterPortfoliosWithInstructions } from "@/composables/usePortfolioUtils";
import PortfolioInstructionsDisplay from "@/dashboard/production_strategy/overview/PortfolioInstructionsDisplay.vue";
import type { Portfolio, RegistryDevice } from "@/types";
import { computed } from "vue";

export interface PPAStrategyOverviewProps {
  portfolios: Portfolio[];
  registryDevices: RegistryDevice[];
}

const props = defineProps<PPAStrategyOverviewProps>();

const ppaPortfoliosWithInstructions = computed(() => {
  const ppaPortfolios = props.portfolios.filter(
    (p) => p.portfolio_type === "PPA"
  );
  return filterPortfoliosWithInstructions(ppaPortfolios);
});
</script>
